import { connect } from 'react-redux';
import { IStateType } from '../../../../store/models/root.interface';
import {
    closeSideBar,
    getIsOpen
} from '../../../../store/sidebar';
import { Instances } from '../../../../constants';
import EditIpConfiguration, {
    DispatchPropsType,
    MapStatePropsType,
} from '../organisms/editConfiguration';
import { getParams } from '../../../../store/sidebar';
import { requestObject } from '../../../../store/Object';
import { requestObjects } from '../../../../store/Objects';

const mapStateToProps = (state: IStateType) => ({
    sidebarVisibility: getIsOpen(state),
    params: getParams(state)
});

const mapDispatchToProps = {
    onClose: () => {
        return closeSideBar();
    },
    onEditIpConfiguration: (data: any, callBack: any) =>
        requestObject(
            Instances.IpConfiguration,
            undefined,
            undefined,
            'PUT',
            true,
            true,
            data,
            callBack
        ),
    onLoad: (
        filters?: Record<string, any>,
        searchTerm?: string,
        property?: string
    ) =>
        requestObjects(Instances.IpConfiguration, filters, {
            searchTerm,
            property
        })
};

export default connect<MapStatePropsType, DispatchPropsType, unknown, IStateType>(
    mapStateToProps,
    mapDispatchToProps
)(EditIpConfiguration);
